import React from 'react';
import './styled.css';

import Logo from '../../assets/images/Logo.webp';
import Banner from '../../assets/images/banner.webp';

export default function Header() {
  return (
    <div className='div-header'>
      <div className='header-logo'>
        <img
          alt='Logo do evento'
          src={Logo}
          className='img-logo'
        />
      </div>
      <div className='div-banner'>
        <img
          alt='Banner do evento'
          src='https://s3.amazonaws.com/bucket.app.eventos/gallery/8029badb-d64c-4af8-9f52-59b60e346767/2025/7d7fd2ac-7037-4395-b857-e406286bed7c.webp?AWSAccessKeyId=AKIA57MDOGUHBJQSZPNS&Expires=2095320609&Signature=Xl87k6Vfvhf1K2nHmq8Wis5hkY8%3D'
          className='header-img'
        />
      </div>
    </div>
  );
}
